<script>
import {mapGetters} from 'vuex'
import List from '../../../mixins/list/list'

export default {
    name: 'live-offers',
    mixins:[List],
    computed: 
    {
        ...mapGetters({
            items: 'offersLive'
        }),
    },
    data()
    {
        return {
            action: 
            {
                fetch: 'offersFetchLive',
                reorder: 'offerReorder'
            },
            id: 'offer_id',
            subPageName: 'offers-subpages',
        }
    },
}
</script>

<template lang="html">
    <div >
        <relive-modal ref="reliveSingleModal" noButton @fetch="fetch" :items="selectedHelper"  type="offerAction"></relive-modal>
        <suspend-modal ref="suspendSingleModal" noButton @fetch="fetch" :items="selectedHelper" type="offerAction"></suspend-modal>
        <div class="py-2 px-2 row">
            <div class="col">
                <router-link :to="{ name:'offer-create'}" class="engage-button blue text-white">
                    <i class="fal fa-plus-circle fa-xs mr-2"></i>
                    Create
                </router-link>
                <suspend-modal class="d-inline-block" @fetch="fetch" :items="selectedItems" type="offerAction"></suspend-modal>
                <archive-modal @fetch="fetch" class="d-inline-block" :items="selectedItems"  type="offerAction"></archive-modal>
            </div>
            <div class="col-2">
                <channel-filter>

                </channel-filter>
            </div>
            <div class="col-2 float-right">
                <simple-input type="text" noRadius v-model="search" icon="fal fa-search" placeholder="Search"></simple-input>
            </div>
        </div>
        <table class="engage-table" v-if="items.data && items.data.length != 0">
            <thead>
                <tr>
                    <th class="pl-3 pr-2 w-40px">
                        <choice-input type="checkbox" v-model="all_selected"></choice-input>
                    </th>
                    <th></th>
                    <order-column field='id'>
                        ID
                    </order-column>
                    <order-column field='name'>
                        Offer
                    </order-column>
                    <th>Channel</th>
                    <order-column field='expires_at'>
                        Expires
                    </order-column>
                    <th class="text-right">Revenue</th>
                    <th class="text-right">Profit</th>
                    <th class="text-right">ROI</th>
                    <order-column class="text-center" field='order'>
                        <i class="fal fa-list-ul"></i>
                    </order-column>
                    <th class="text-center">
                        <i class="far fa-globe"></i>
                    </th>
                </tr>
            </thead>
            <draggable v-model="items.data" element="tbody" @change="onDragEnd" v-if="items && items.data">
                <tr
                    v-for="(offer,index) in items.data"
                    :key="offer.id"
                    class="draggable"
                    >
                    <td class="pl-3 pr-2">
                        <choice-input type="checkbox" v-if="selected[index]" v-model="selected[index].selected"></choice-input>
                    </td>
                    <td>
                        <template v-if="offer.desktop_images && offer.desktop_images[0]">
                            <img class="table-img" :src="offer.desktop_images[0].display_url" alt="Desktop">
                        </template>
                    </td>
                    <td class="cp">
                        <router-link :to="{name:'offer-edit', params: {item: offer.id, slug: 'creative'}}">
                            #{{ offer.offer_id }}
                        </router-link>
                    </td>
                    <td class="font-weight-bold cp">
                        <router-link :to="{name:'offer-edit', params: {item: offer.id, slug: 'creative'}}">
                            {{ offer.name }}
                        </router-link>
                    </td>
                    <td>
                        <template v-if="offer.client && offer.client.name">
                            <span>
                            {{ offer.client.name }}
                            </span>
                        </template>
                    </td>
                    <td>
                        <template v-if="offer.expires_at">
                            {{ offer.expires_at | toDate }}
                        </template>
                    </td>
                    <td class="text-right">
                        ${{ offer.revenue | toMoney }}
                    </td>
                    <td class="text-right">${{ offer.profit | toMoney }}</td>
                    <td class="text-right">{{ offer.roi }}%</td>
                    <td class="text-center">{{ offer.order }}</td>
                    <td class="text-center cp">
                        <div class="offer-status">
                            <div class="status">
                                <i v-if="offer.is_active"  class="fas fa-play-circle text-green"></i>
                                <i v-else class="fas fa-pause-circle text-orange"></i>
                            </div>
                            <div class="buttons">
                                <i @click="setInActive(offer)" v-if="offer.is_active" class="fas fa-pause-circle text-orange"></i>
                                <i @click="setActive(offer)" v-else class="fas fa-play-circle text-green"></i>
                            </div>
                        </div>
                    </td>
                </tr>
            </draggable>
        </table>
        <div v-else class="px-2 py-4">
            <smile-with-text header="No Live Offers yet" text="There are no offers here" faType="fal" icon="frown"></smile-with-text>
        </div>
        <paginator :items="items" :subPageName="subPageName" :loading="loading"></paginator>
    </div>
</template>

<style lang="scss">
.offer-status {
    position: relative;
    display: inline-block;
    width: 21px;
    height: 21px;
    vertical-align: middle;

    .buttons {
        position: absolute;
        opacity: 0;
        transition: opacity .4s;
    }

    .status {
        position: absolute;
        opacity: 1;
        transition: opacity .4s;
    }

    &:hover {
        .buttons {
            opacity: 1;
        }

        .status {
            opacity: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/offers/subpages/Live.vue